import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import { Link } from "react-router-dom";
import Navigationtitle from "./include/Navigationtitle";
import { svg, manWithHammer } from "../constants/Images";
import { Klp } from "../constants/Images";
import DataService from "../services/tutorial.service";
import { actlistData } from "../actions/index";
import { auctiondefaultLogo } from "./../constants/Images";
import {
  getDatabase,
  ref,
  remove,
  onValue,
  set,
  update,
} from "firebase/database";

function Dashboard(match) {
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [isActive, setActive] = useState(false);
  const loginuser = useSelector((state) => state.setUserlog);
  const refresh = useSelector((state) => state.setRefresh);
  const [cid, setCid] = useState(loginuser["cid"]);
  const [token, settoken] = useState(loginuser["token"]);
  const getpageData = useSelector((state) => state.setactlistData);
  const [filteredAuctions, setFilteredAuctions] = useState([]);

  const fetchData = async () => {
    setActive(true);
    // console.log("fetch cid:" + cid);
    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        authorization: JSON.stringify([
          { cid: cid, token: loginuser["token"] },
        ]),
      },
    };

    await DataService.listAuction({ myauction: 1 }, hdr)
      .then((res) => {
        let response = res.data;
        console.log(response);
        if (response.success == true) {
          let responsedata = response.data;
          setData(responsedata);
          dispatch(actlistData({ responsedata }));
        }

        setActive(false);
      })
      .catch(() => {
        // console.log("Not valid");
        setActive(false);
      });
  };

  const setauction = (ai, an) => {
    localStorage.setItem("auction_id", ai);
    localStorage.setItem("auction_name", an);
  };

  useEffect(() => {
    if (refresh == 1) {
      fetchData(0);
    } else {
      if (getpageData == 0) {
        fetchData(0);
      } else {
        if (getpageData.responsedata.cid == cid) {
          setData(getpageData.responsedata);
        } else {
          let responsedata = getpageData.responsedata;
          responsedata.list = [];
          setData(responsedata);
          fetchData(0);
        }
      }
    }

    window.scrollTo(0, 0);
  }, [refresh]);
  function acpgo() {
    document.getElementById("acp1").value = cid;
    document.getElementById("acp2").value = 0;
    document.getElementById("acp3").value = token;
    document.getElementById("acpform").submit();
  }

  useEffect(() => {
    const now = new Date();
    // console.log(now)

    const futureAuctions = data?.list?.filter((dt) => {
      const auctionDateTime = new Date(`${dt.dt}T${dt.atm}`);

      return auctionDateTime >= now;
    });

    setFilteredAuctions(futureAuctions);
  }, [data]);

  return (
    <>
      <div>
        <Navigationtitle data={match} />
        <form
          id="acpform"
          method="get"
          action="https://superplayerauction.com/manage/"
          target="_blank"
        >
          <input type="hidden" id="acp1" name="cid" />
          <input type="hidden" id="acp2" name="aid" />
          <input type="hidden" id="acp3" name="fkey" />
          <input type="hidden" name="frnt" value="1" />
          {/* <input type="hidden" name="loginbyadmin" value="1" /> */}
        </form>
        <div
          id="top-categories"
          className="top-cat-area padding-top-22px bottom-less"
        >
          <div className="container padding-left-0px">
            <div className="row">
              <div className="top-cat-items">
                <div className="col-md-10 col-sm-10">
                  <div className="row">
                    <div className="col-md-4 col-sm-12 padding-right-40px width-110per">
                      <div className="item dashboard-card new-auction">
                        <Link to="/new-auction">
                          <div className="dashboard-card-container">
                            <div className="dashboard-card-container-top">
                              <div className="margin-right-12px">{svg.Bid}</div>
                              <div>
                                <h2 className="dashboard-card-light-text">
                                  <span className="dashboard-card-bold-text">
                                    New{" "}
                                  </span>
                                  Auction
                                </h2>
                              </div>
                            </div>
                          </div>
                        </Link>
                      </div>
                    </div>

                    <div className="col-md-4 col-sm-12 padding-right-40px width-110per">
                      <div className="item dashboard-card join-auction">
                        <Link to="/join-auction-code">
                          <div className="dashboard-card-container">
                            <div className="dashboard-card-container-top">
                              <div className="margin-right-12px">
                                {svg.Hummer}
                              </div>
                              <div>
                                <h2 className="dashboard-card-light-text">
                                  <span className="dashboard-card-bold-text">
                                    Join{" "}
                                  </span>
                                  Auction
                                </h2>
                              </div>
                            </div>
                          </div>
                        </Link>
                      </div>
                    </div>

                    <div className="col-md-4 col-sm-12 padding-right-40px width-110per">
                      <div className="item dashboard-card my-auction">
                        <Link to="/my-auction">
                          <div className="dashboard-card-container">
                            <div className="dashboard-card-container-top">
                              <div className="margin-right-12px">
                                {svg.HummerMan}
                              </div>
                              <div>
                                <h2 className="dashboard-card-light-text">
                                  <span className="dashboard-card-bold-text">
                                    My{" "}
                                  </span>
                                  Auction
                                </h2>
                              </div>
                            </div>
                          </div>
                        </Link>
                      </div>
                    </div>

                    <div className="css-property-for-last-card">
                      <div className="col-md-5 col-sm-12 padding-right-40px width-110per">
                        <div className="item dashboard-card auction-panel">
                          <Link to="">
                            <div
                              onClick={acpgo}
                              className="dashboard-card-container"
                            >
                              <div className="dashboard-card-container-top">
                                <div className="margin-right-12px">
                                  {svg.TripleBid}
                                </div>
                                <div>
                                  <h2 className="dashboard-card-light-text">
                                    <span className="dashboard-card-bold-text">
                                      Auction{" "}
                                    </span>
                                    Panel
                                  </h2>
                                </div>
                              </div>
                            </div>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Auction lists */}
                  {data?.list && (
                    <>
                      <div className="custhead1">Your Auctions</div>
                    </>
                  )}

                  <div className="row">
                    {/* <ul>
                      {filteredAuctions?.length > 0 ? (
                        filteredAuctions?.map((dt, i) => (
                          <li key={i}>
                            {dt.dt}
                            {dt.atm}{" "}
                          </li>
                        ))
                      ) : (
                        <p>No auction found</p>
                      )}
                    </ul> */}

                    <ul>
                      {filteredAuctions?.length > 0
                        ? filteredAuctions?.map((dt, i) => (
                            <li key={i}>
                              <div
                                className="col-md-4 col-sm-12 padding-right-40px width-110per"
                                
                              >
                                <div className="item dashboard-card new-auction btmdash">
                                  <Link
                                    title={dt.aname}
                                    onClick={() => setauction(dt.aid, dt.aname)}
                                    to="/auction-detail"
                                  >
                                    <div className="dashboard-bottom">
                                      <div className="dashboard-bottom-img-section">
                                        <img
                                          src={
                                            dt.logo
                                              ? data.path + dt.logo
                                              : auctiondefaultLogo
                                          }
                                          alt=""
                                        />
                                      </div>
                                      <div>
                                        <div className="dashboard-bottom-text">
                                          {dt.aname}
                                          <p className="btmtime">
                                            {dt.dt}&nbsp;{dt.atm}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </Link>
                                </div>
                              </div>
                            </li>
                          ))
                        : ""}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Dashboard;
